import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import { chartThemeColorsWeek } from "./index";
import { FiBarChart2, FiTrendingUp } from "react-icons/fi";

const parseData = (data) => {
  if (data && (data.length || Object.keys(data)?.length))
    return {
      bar: data.bar ? Object.values(data.bar) : Array.isArray(data) ? data : [],
    };
  return {
    bar: [],
  };
};

const BarWidget = ({ data, heading, size, handleReq = null, url=null, loading=false }) => {
    const [formattedData, setFormattedData] = useState({
      bar: null,
    });
    const [chartType, setChartType] = useState('hbar');
    
    useEffect(() => {
      if(data){
        setFormattedData(parseData(data));
      }else{
        setFormattedData({
          bar: null,
        });
      }
    }, [data]);
     
  return (
    <div className={`col row mx-0 mt-3 ${size} px-2 position-relative`}>
      <div className="row px-0 mx-0 justify-content-between col col-12 mt-0">
        <div className="dashboard__card col col-12 w-100 flex-basis-100">
          {heading ? (
            <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
              <h5 className="my-0 text-capitalize" style={{ fontWeight: 600, color: '#333' }}>{heading}</h5>
              {formattedData.bar && (
                <div className="d-flex align-items-center" style={{ gap: '2px', background: '#e9ecef', padding: '2px', borderRadius: '16px' }}>
                  <div 
                    className="d-flex justify-content-center align-items-center rounded-circle" 
                    style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'bar' ? '#fff' : 'transparent', boxShadow: chartType === 'bar' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                    onClick={() => setChartType('bar')}
                    title="Vertical Bar Chart"
                  >
                    <FiBarChart2 size={14} color={chartType === 'bar' ? '#0d6efd' : '#495057'} />
                  </div>
                  <div 
                    className="d-flex justify-content-center align-items-center rounded-circle" 
                    style={{ width: '24px', height: '24px', cursor: 'pointer', transition: 'all 0.2s', background: chartType === 'hbar' ? '#fff' : 'transparent', boxShadow: chartType === 'hbar' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none' }}
                    onClick={() => setChartType('hbar')}
                    title="Horizontal Bar Chart"
                  >
                    <FiBarChart2 size={14} style={{ transform: 'rotate(90deg)' }} color={chartType === 'hbar' ? '#0d6efd' : '#495057'} />
                  </div>
                </div>
              )}
            </div>
          ) : ""}
           <div className="d-flex flex-col mx-3 my-2" style={{ gap: "1rem" }}>
           </div>
           {
              formattedData.bar ? (
                <Chart
                  width="100%"
                  height="220px"
                  type={chartType === 'hbar' ? 'bar' : chartType}
                  series={[
                    {
                      name: heading,
                      data: formattedData.bar.map((data) => parseFloat(data.value)),
                    },
                  ]}
                  options={{
                    chart: {
                      type: chartType === 'hbar' ? 'bar' : chartType,
                      toolbar: { 
                        show: true,
                        tools: {
                          download: true,
                          selection: false,
                          zoom: false,
                          zoomin: false,
                          zoomout: false,
                          pan: false,
                          reset: false
                        }
                      },
                      animations: { enabled: true, easing: 'easeinout', speed: 800 }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: chartType === 'hbar',
                        borderRadius: 5,
                        distributed: true,
                      },
                    },
                    colors: chartThemeColorsWeek,
                    dataLabels: {
                      enabled: false,
                    },
                    tooltip: {/*
                      enabled: true,
                      custom: ({ series, seriesIndex, dataPointIndex, w }) =>
                        `<div style="color:white;background-color:${chartThemeColorsWeek[seriesIndex]};" className="p-2">
                    <p >${
                      formattedData.bar[dataPointIndex].value_formatted
                        ? formattedData.bar[dataPointIndex].value_formatted
                        : formattedData.bar[dataPointIndex].value
                    }</p>
                    </div>`,
                  */},
                    xaxis: {
                        categories: formattedData.bar.map((data) => data.name),
                        labels: { 
                          show: true,
                          style:{
                            fontSize:"9.5px"
                          }
                        },
                        tickAmount: 3,
                        tickPlacement: 'between',
                      },
                      yaxis: {
                          labels: {
                              formatter: function (value) {
                                  return value;
                                },
                                style:{
                                  fontSize:"10px"
                                }
                            },
                      },
                  }}
                />
              ):(
                <div className="btn_load">
                  {
                    loading ? (
                      <>
                        {/*loading */}
                        <CustomSpinLoader loading={loading}/>
                      </>
                    ) : (
                      <button className="btn btn-sm btn-primary rounded-md" onClick={()=> url && handleReq(url)}>Load Data</button>
                    )
                  }
                </div>
              )
           }
          
        </div>
      </div>
    </div>
  )
}

export default BarWidget
